import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-slate-50 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid grid-cols-2 md:grid-cols-4 gap-8 text-sm">
        <div className="col-span-2">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-8 h-8 rounded-lg bg-emerald-800 flex items-center justify-center text-white">
              <MapPin className="w-4 h-4" />
            </div>
            <span className="font-bold text-slate-900" style={{ fontFamily: "Outfit" }}>ApnaIslamabad.com</span>
          </div>
          <p className="text-slate-600 max-w-md">Islamabad's hyperlocal directory. Find verified local businesses, chat on WhatsApp, read reviews, grab deals — all in one place.</p>
        </div>
        <div>
          <div className="font-semibold text-slate-900 mb-3">Explore</div>
          <ul className="space-y-2 text-slate-600">
            <li><Link to="/search?category=home_services" className="hover:text-emerald-700">Home Services</Link></li>
            <li><Link to="/search?category=food_restaurants" className="hover:text-emerald-700">Food & Restaurants</Link></li>
            <li><Link to="/search?category=salons_beauty" className="hover:text-emerald-700">Salons & Beauty</Link></li>
            <li><Link to="/deals" className="hover:text-emerald-700">Deals & Offers</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-semibold text-slate-900 mb-3">Business</div>
          <ul className="space-y-2 text-slate-600">
            <li><Link to="/login?mode=signup" className="hover:text-emerald-700">List your business</Link></li>
            <li><Link to="/dashboard" className="hover:text-emerald-700">Owner dashboard</Link></li>
            <li><span className="text-slate-500">Terms &amp; Policy</span></li>
            <li><span className="text-slate-500">48-hour takedown</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-200 py-4 text-center text-xs text-slate-500">© 2026 ApnaIslamabad.com — Built for Islamabad, with Islamabad.</div>
    </footer>
  );
}
